import { useEffect, useRef } from "react";

export const useAsync = <T>(
    asyncFn: (signal?: AbortSignal) => Promise<T>,
    onSuccess?: (data: T) => void,

    onError?: (err: Error) => void
) => {
    const fetchRef = useRef<{ promise: Promise<T>; abort: AbortController }>({
        promise: null,
        abort: null
    });

    useEffect(() => {
        let isActive = true;

        fetchRef.current?.abort?.abort();
        // track current promise, and abort signal
        const abortController = new AbortController();

        const promise = asyncFn(abortController.signal);

        fetchRef.current.promise = promise;
        fetchRef.current.abort = abortController;

        promise
            .then(data => {
                const isLatest = fetchRef.current.promise === promise;
                if (isActive && isLatest && onSuccess) onSuccess(data);
            })
            .catch(err => {
                const isLatest = fetchRef.current.promise === promise;
                if (isActive && isLatest && onError) onError(err);
            });

        return () => {
            isActive = false;
        };
    }, [asyncFn, onSuccess, onError]);
};
